// 收支流水
export default {
    heard_title: "收支流水表",
    fl_store: "门店:",
    fp_store: "请选择门店",
    fl_type: "收入/支出:",
    fp_type: "请选择",
    option_income: "收入",
    option_pay: "支出",
    fl_category: "收支类型",
    fp_category: "请选择",
    fl_item: "项目名称：",
    fp_item: "请输入",
    fl_operator: "操作人:",
    fp_operator: "请输入",
    fl_createTime: "发生时间:",
    fp_startTime: "开始日期",
    fp_endTime: "结束日期",

    // 统计表
    title_statistic: "统计表",
    btn_exportExcel: "导出Excel",
    btn_fold: "收起/展开",
    sum_text: "结余",
    tl_type: "收入/支出",
    tl_totalAmount: "合计",
    tl_cashAmount: "现金",
    tl_alipayAmount: "支付宝",
    tl_wechatpayAmount: "微信",
    tl_walletAmount: "钱包余额",
    tl_posAmount: "刷卡",
    tl_otherAmount: "其他",

    // 收支明细
    title_orderDetail: "订单收支明细",
    btn_addOrder: "记一笔收支明细",
    tl_actionTime: "记录时间",
    tl_operator: "操作人",
    tl_payor: "付款人",
    tl_mobile: "联系电话",
    tl_categoryName: "收支类型",
    tl_item: "项目名称",
    tl_paymentModel: "支付方式",
    tl_orderType: "收入/支出",
    tl_amount: "金额",
    tl_memo: "备注",

    // 记录收支数据表单
    dt_orderDetail: "收支流水",
    dl_actionTime: "时间:",
    dp_actionTime: "请选择日期与时间",
    dl_type: "类型:",
    radio_income: "收入",
    radio_pay: "支出",
    dl_payor: "付款人:",
    memo_text: "(选填)",
    dl_mobile: "手机号",
    dl_category: "收支类型:",
    dp_category: "请选择收入项目",
    dl_item: "项目名称:",
    dl_amount: "金额:",
    dl_paymentModel: "支付方式:",
    dp_paymentModel: "请选择支付方式",
    option_cash: "现金",
    option_alipay: "支付宝",
    option_wechartPay: "微信",
    option_other: "其他",
    option_pos: "刷卡",
    option_wallet: "钱包余额",
    dl_memo: "备注",
    dp_memo: "最多可输入10字",
    surplus_text: "结余",

    ft_income: "收入",
    ft_pay: "支出",

    ft_wechart: "微信",
    ft_cash: "现金",
    ft_wallet: "钱包余额",
    ft_alipay: "支付宝",
    ft_pos: "刷卡",
    ft_other: "其他"
};
